import type { EditorialItem, MediaFormat, MediaTemplate } from './api';

type MediaIdentity = {
  editorialItemId: string | null;
  sourceAssetId: string | null;
  format: MediaFormat;
  template: MediaTemplate;
  editorialItem: EditorialItem | null;
  title: string;
  caption: string;
  variation: string;
};

/** Stable, bounded key without exposing editorial text in job metadata. */
export async function mediaIdempotencyKey(
  input: MediaIdentity,
): Promise<string> {
  const bytes = new TextEncoder().encode(JSON.stringify(input));
  const digest = await crypto.subtle.digest('SHA-256', bytes);
  return (
    'media-v2:' +
    Array.from(new Uint8Array(digest), (byte) =>
      byte.toString(16).padStart(2, '0'),
    ).join('')
  );
}
